import { useAppendQueryParams } from '../utils/useAppendQueryParams';

export const useRedirect = () => {
  const appendQueryParams = useAppendQueryParams();
  return (href: string) => {
    if (typeof window !== 'undefined') {
      window.location.href = appendQueryParams(href);
    }
  };
};
